var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-actions',{ref:"formCard",attrs:{"title":("Tambah " + (_vm.$route.meta.name.singular)),"no-actions":""}},[_c('form-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }